<template>
  <div class="head header-border">
    <div style="display: none;"><img src="../assets/LOGO/LOGO.png" title="LOGO" alt="LOGO"></div>
    <div class="container">
      <el-row :gutter="5">
        <el-col :xs="20" :sm="20" :md="7" :lg="7" :xl="7">
          <div class="logo" style="line-height: 130px !important;float: left;"><img src="../assets/img/logo-head.png" style="width:100%;height:auto;"></div>
        </el-col>
        <!-- <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <div class="message">
            <i class="el-icon-phone"></i>
            <div class="message-phone">
              0311-87375060/87375065
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <div class="message">
            <i class="el-icon-message"></i>
            <div class="message-email">
              caoyanshuang@xjguochao.com
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
          <div class="message" style="float: left;margin-left: 15px;">
            <i class="el-icon-location-outline"></i>
            <div class="message-address">
              辛集市龙泉街西段9号
            </div>
          </div>
        </el-col> -->
      </el-row>
    </div>
    <div class="navheader">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="/">首 页</el-menu-item>
        <el-menu-item index="/about">公司简介</el-menu-item>
        <el-menu-item index="/history">公司历程</el-menu-item>
        <el-submenu index="/news">
          <template slot="title">新闻中心</template>
          <el-menu-item index="/news">最新动态</el-menu-item>
          <el-menu-item index="/cooper">企校合作</el-menu-item>
        </el-submenu>
        <el-menu-item index="/organ">公司机构</el-menu-item>
        <el-menu-item index="/case">成功案例</el-menu-item>
        <el-menu-item index="/honor">公司荣誉</el-menu-item>
        <el-menu-item index="/recruit">诚聘英才</el-menu-item>
        <el-menu-item index="/contact">联系我们</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        visible: false,
        activeIndex: this.$route.path
      }
    },
    methods: {
      handleSelect(key, keyPath) {
        this.$router.push(key);
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Navheader.vue